import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { UserDeletionHistoryService } from './user-deletion-history.service';
import { NotificationService } from '../../../../../common/services';
import { UserDeletionHistoryModel } from '../models/user-deletion-history.model';
import { UserDeletionHistoryInitialState, UserDeletionHistoryLoad } from './user-deletion-history.actions';
import {
  Error,
  CustomHttpErrorResponse,
  ListServerPaginationStateModel,
  LIST_SERVER_PAGINATION_INITIAL_STATE,
} from '../../../../../common';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type UserDeletionHistoryStateModel = ListServerPaginationStateModel<UserDeletionHistoryModel>;

const initialState: UserDeletionHistoryStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<UserDeletionHistoryStateModel>({
  name: 'UserDeletionHistory',
  defaults: initialState,
})
@Injectable()
export class UserDeletionHistoryState {
  constructor(
    private userDeletionHistoryService: UserDeletionHistoryService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: UserDeletionHistoryStateModel): UserDeletionHistoryStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: UserDeletionHistoryStateModel): boolean {
    return state.loaded;
  }

  @Action(UserDeletionHistoryLoad)
  getDeletionHistoryList(
    ctx: StateContext<UserDeletionHistoryStateModel>,
    { payload }: UserDeletionHistoryLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.userDeletionHistoryService.getUserDeletionHistory(payload).pipe(
      map((response: UserDeletionHistoryStateModel) => {
        ctx.patchState({ ...response });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(UserDeletionHistoryInitialState)
  setInitialState(ctx: StateContext<UserDeletionHistoryStateModel>): void {
    ctx.setState(initialState);
  }
}
